import type { ReactNode } from 'react'

export type DescriptionWrapperProps = {
  children: ReactNode
  visible: boolean
}

export const DescriptionWrapper = ({ children, visible }: DescriptionWrapperProps) => {
  if (!visible) {
    return null
  }

  return (
    <div className="flex w-auto max-w-full flex-[1_0_auto] flex-col items-start justify-start gap-0.5 lg:max-w-[28%] md:w-1/2 md:max-w-full sm:w-full">
      {children}
    </div>
  )
}
